import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from "react";

import { Badge as BaseBadge } from "@radix-ui/themes";

import { semanticColor as semanticColorMapper } from "../styles";

type BadgeProps = {
  semanticColor?: keyof typeof semanticColorMapper;
} & ComponentPropsWithoutRef<typeof BaseBadge>;

type BadgeRef = ElementRef<typeof BaseBadge>;

const Badge = forwardRef<
  BadgeRef,
  BadgeProps
>((props, ref) => {
  const {
    className,
    color,
    semanticColor,
    ...badgeProps
  } = props;

  return (
    <BaseBadge
      {...badgeProps}
      className={className}
      color={(semanticColor && semanticColorMapper[semanticColor]) || color}
      ref={ref}
    />
  );
});
Badge.displayName = BaseBadge.displayName;

export { Badge, type BadgeProps };
